module.exports = __webpack_public_path__ + "img/advance-3-1.svg";